import { render, staticRenderFns } from "./OrderCartSidebar.vue?vue&type=template&id=661c9799&"
import script from "./OrderCartSidebar.vue?vue&type=script&lang=js&"
export * from "./OrderCartSidebar.vue?vue&type=script&lang=js&"
import style0 from "./OrderCartSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports